(function () {
  if (!window.EgPdpEasyAssembly) {
    window.EgPdpEasyAssembly = {
      init(root) {
        const scopeRoot = root instanceof Element ? root : document;
        const sections = scopeRoot.querySelectorAll('[data-eg-pdp-easy-assembly]:not([data-easy-assembly-ready="true"])');

        sections.forEach((section) => {
          const track = section.querySelector('[data-easy-assembly-track]');
          const prevButtons = Array.from(section.querySelectorAll('[data-easy-assembly-prev]'));
          const nextButtons = Array.from(section.querySelectorAll('[data-easy-assembly-next]'));

          if (!track) {
            section.dataset.easyAssemblyReady = 'true';
            return;
          }

          section.dataset.easyAssemblyReady = 'true';

          const controller = new AbortController();
          const signal = controller.signal;
          const resizeObserver = 'ResizeObserver' in window ? new ResizeObserver(updateControls) : null;

          section.__egEasyAssemblyController = controller;

          function getScrollStep() {
            const firstCard = track.querySelector('.eg-pdp-easy-assembly__step');
            if (!firstCard) {
              return track.clientWidth * 0.8;
            }

            const trackStyles = window.getComputedStyle(track);
            const gap = parseFloat(trackStyles.columnGap || trackStyles.gap || 0);
            return firstCard.getBoundingClientRect().width + gap;
          }

          function updateControls() {
            const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth - 2);
            const currentScroll = Math.max(0, track.scrollLeft);
            const canScroll = maxScroll > 6;

            section.dataset.canScroll = canScroll ? 'true' : 'false';
            prevButtons.forEach((button) => {
              button.disabled = !canScroll || currentScroll <= 2;
            });
            nextButtons.forEach((button) => {
              button.disabled = !canScroll || currentScroll >= maxScroll;
            });
          }

          function scrollByStep(direction) {
            track.scrollBy({
              left: direction * getScrollStep(),
              behavior: 'smooth'
            });
          }

          prevButtons.forEach((button) => {
            button.addEventListener('click', () => {
              scrollByStep(-1);
            }, { signal });
          });

          nextButtons.forEach((button) => {
            button.addEventListener('click', () => {
              scrollByStep(1);
            }, { signal });
          });

          track.addEventListener('scroll', updateControls, { passive: true, signal });
          window.addEventListener('resize', updateControls, { signal });

          track.querySelectorAll('img').forEach((image) => {
            image.addEventListener('load', updateControls, { signal });
          });

          resizeObserver?.observe(track);

          document.addEventListener('shopify:block:select', (event) => {
            const block = event.target.closest('.eg-pdp-easy-assembly__step');

            if (!block || !section.contains(block)) {
              return;
            }

            block.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'start'
            });

            window.setTimeout(updateControls, 220);
          }, { signal });

          updateControls();
          window.setTimeout(updateControls, 180);
        });
      }
    };

    document.addEventListener('shopify:section:load', (event) => {
      window.EgPdpEasyAssembly.init(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target.querySelector('[data-eg-pdp-easy-assembly]');

      if (!section || !section.__egEasyAssemblyController) {
        return;
      }

      section.__egEasyAssemblyController.abort();
      delete section.__egEasyAssemblyController;
      delete section.dataset.easyAssemblyReady;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.EgPdpEasyAssembly.init(document);
    }, { once: true });
  } else {
    window.EgPdpEasyAssembly.init(document);
  }
})();
